export default "__VITE_ASSET__IWzwACWo__"